// Hook per rilevamento stato online/offline con banner automatico
import { useState, useEffect } from 'react'

export function useOffline() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)
  const [wasOffline, setWasOffline] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false)
      setWasOffline(true)
      // Rimuove il banner "reconnected" dopo 3 secondi
      setTimeout(() => setWasOffline(false), 3000)
    }

    const handleOffline = () => {
      setIsOffline(true)
      setWasOffline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return { isOffline, wasOffline }
}
